<template>
  <div class="foot">
    <p class="top">联系我们 service@kandianketang.com</p>
    <p>
      <a href="https://beian.miit.gov.cn/" target="_blank">
        京ICP备14002947号-93
      </a>
    </p>
    <p>公司地址：北京市朝阳区来广营科技园6号楼</p>
  </div>
</template>

<script>
export default {
  name: 'foo',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="./scss/footer.scss"></style>



// WEBPACK FOOTER //
// src/components/layout/foot.vue